"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_js_1 = __importDefault(require("i18n-js"));
const en_json_1 = __importDefault(require("./locales/en.json"));
const de_json_1 = __importDefault(require("./locales/de.json"));
const de_x_du_json_1 = __importDefault(require("./locales/de-x-du.json"));
const es_json_1 = __importDefault(require("./locales/es.json"));
const fi_json_1 = __importDefault(require("./locales/fi.json"));
const fr_json_1 = __importDefault(require("./locales/fr.json"));
const hr_json_1 = __importDefault(require("./locales/hr.json"));
const it_json_1 = __importDefault(require("./locales/it.json"));
const no_json_1 = __importDefault(require("./locales/no.json"));
const nl_json_1 = __importDefault(require("./locales/nl.json"));
const pt_json_1 = __importDefault(require("./locales/pt.json"));
const ru_json_1 = __importDefault(require("./locales/ru.json"));
const sv_json_1 = __importDefault(require("./locales/sv.json"));
const tr_json_1 = __importDefault(require("./locales/tr.json"));
const sl_json_1 = __importDefault(require("./locales/sl.json"));
const vi_json_1 = __importDefault(require("./locales/vi.json"));
const ar_json_1 = __importDefault(require("./locales/ar.json"));
i18n_js_1.default.translations = {
    en: en_json_1.default,
    ar: ar_json_1.default,
    de: de_json_1.default,
    derobinson: de_x_du_json_1.default,
    es: es_json_1.default,
    fi: fi_json_1.default,
    fr: fr_json_1.default,
    hr: hr_json_1.default,
    it: it_json_1.default,
    no: no_json_1.default,
    nl: nl_json_1.default,
    pt: pt_json_1.default,
    ru: ru_json_1.default,
    sv: sv_json_1.default,
    tr: tr_json_1.default,
    sl: sl_json_1.default,
    vi: vi_json_1.default,
};
i18n_js_1.default.fallbacks = true;
i18n_js_1.default.defaultLocale = 'de';
exports.default = i18n_js_1.default;
